<template>
<div>

  <div v-if="!spinner" class="form-group">
  <brandBySupplier v-if="brands" @close="brands=false" @update="setSupplierId"></brandBySupplier>  
  <label for="fornitore"><strong>FORNITORE</strong></label>
  <div class="input-group">  
    <select ref="sel" id="supplier" :required="props.required" :disabled="!props.isActive"  @change="customEmit(supplierId,$event)" class="form-control" v-model="supplierId" >
      <option v-if="props.optionBase==true" value="0"> -- TUTTI I FORNITORI -- </option> 
      <option v-for="(item,index) in items" :value="item.supplierId" :key="index">{{item.supplier}}</option>        
    </select>
    <a title="RICERCA PER BRAND" href="#" @click="brands=!brands" class="btn btn-light btn-sm " tabindex="-1" role="button" aria-disabled="true">
      <i  class="fas fa-binoculars ml-1 mr-2" aria-hidden="true"></i>
     RICERCA PER BRAND  
      
      </a>
      
  </div>

      <small v-if="props.small">Selezionare un fornitore dall'elenco</small>    
  </div>
  <div v-else>
      <div class="spinner-border spinner-border-sm" role="status">
          <span class="sr-only">Loading...</span>
      </div>
  </div>    

</div>
</template>

<script>
import api              from "@/api";
import { mapGetters }      from 'vuex';
import brandBySupplier     from '@/components/stat/BrandBySupplier.vue'

export default {
  props : ['props'] , 
  components: { brandBySupplier },
  data() {
    return {

      supplierId             : 0,
      items                  : [],
      spinner                : false,
      brands                 : false,
    
     


     
    };
  },
  mounted: function() {
    
  },
   computed: 
  {  
    ...mapGetters(['company']),
  },  
  created: function() {
   
      this.getData()
     
  },
  methods: 
  {
    customEmit(supplierId,e)
    {
      const text = e.target.options[e.target.selectedIndex].text
      this.$emit('update',supplierId,text)

    },

    setSupplierId(supplierId,text)
    {

      this.supplierId = supplierId     
      this.$emit('update',supplierId,text)
      this.brands = false

    },
        
      
    
    async getData()
    {
      
    
      this.spinner = true
      var sp       = {'sp'  : 'spSupplierSelect'}  
      var data     = {'companyId':this.company.Id}
      var json     = Object.assign(data, sp)    
        await api.post(json).then(res => {                   
          if(res.status==200)
            {
              this.items = res.data.recordsets[0]   
              this.supplierId = this.props.Id      
                         
            }
           else if(res.status==500)
           {
                //console.log(res.data)                
                    
           } 
           else
            {
                
                console.log('Network Error.')                  
                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
            this.spinner = false
        });


    },
      
  
}

}
</script>
<style scoped>

</style>